import React from "react";
import { TableRow, TableData } from "../../components/table";
import { ShimmerBlock } from "../index.styles";

export const OrderSkeleton = ({ rowsCount = 10 }) => {
  return (
    <>
      {Array.from({ length: rowsCount }).map((_, idx) => (
        <TableRow key={idx}>
          <TableData style={{ width: "48px" }}>
            <ShimmerBlock width="16px" height="16px" />
          </TableData>
          <TableData>
            <ShimmerBlock width="100px" />
          </TableData>
          <TableData>
            <ShimmerBlock width="80px" />
          </TableData>
          <TableData>
            <ShimmerBlock width="90px" />
          </TableData>
          <TableData>
            <ShimmerBlock width="95px" />
          </TableData>
          <TableData>
            <ShimmerBlock width="160px" />
          </TableData>
          <TableData rightAlign>
            <ShimmerBlock width="60px" margin="0 0 0 auto" />
          </TableData>
          <TableData rightAlign>
            <ShimmerBlock width="50px" margin="0 0 0 auto" />
          </TableData>
          <TableData rightAlign>
            <ShimmerBlock width="60px" margin="0 0 0 auto" />
          </TableData>
          <TableData centerAlign>
            <ShimmerBlock width="80px" height="22px" margin="0 auto" />
          </TableData>
        </TableRow>
      ))}
    </>
  );
};
